export default __webpack_public_path__ + "static/media/mockup.ce7057ba.png";